import { render, staticRenderFns } from "./echart-pie.vue?vue&type=template&id=c32c7f36&scoped=true"
import script from "./echart-pie.vue?vue&type=script&lang=js"
export * from "./echart-pie.vue?vue&type=script&lang=js"
import style0 from "./echart-pie.vue?vue&type=style&index=0&id=c32c7f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32c7f36",
  null
  
)

export default component.exports